export class CommonConstants {
  public static readonly defaultGUID = "00000000-0000-0000-0000-000000000000";
}